<template>
    <div>
        <!-- <select-box-modal
            v-if="isModal"
            :selectList="options"
            :selectedIndex="innerSelectedIndex"
            :title="title"
            @closeModal="closeModal"
            
        /> -->
        <select-box-location-modal 
            v-if="isModal"
            :option="options"
            :selectedCityIndex="selectedCityIndex"
            :selectedSubcityIndex="selectedSubcityIndex"
            @close="closeModal"
            @select="selectLocation"
        />
        <div name="select-box" class="select-box" @click="openModal">
            <span>{{selectedText}}</span>
            <img style="width: 22px; margin-left: 4px;" src="../../assets/select_icn.png" />
        </div>
    </div>
</template>

<script>
import SelectBoxModal from '@/components/modals/SelectBoxModal2';
import SelectBoxLocationModal from '@/components/modals/SelectBoxLocationModal';

export default {
    name: 'locationSelectBox',
    props: ['options', 'selectedCityIndex', 'selectedSubcityIndex', 'placeHolder', 'title'],
    components: {
        SelectBoxModal,
        SelectBoxLocationModal
    },
    data: function()
    {
        return {
            selectedText: '',
            isModal: false
        }
    },
    mounted: function()
    {
        this.selectedText = this.placeHolder;
        if(this.selectedCityIndex !== -1 && this.selectedSubcityIndex !== -1)
        {
            this.selectedText = this.options[this.selectedCityIndex].cityName + " " + this.options[this.selectedCityIndex].subCities[this.selectedSubcityIndex].name; 
        }
    },
    methods: {
        closeModal: function()
        {
            this.isModal = false;
        },
        selectLocation: function(cityIndex, subcityIndex)
        {
            if(cityIndex !== -1 && subcityIndex !== -1)
            {
                this.selectedText = this.options[cityIndex].cityName + " " + this.options[cityIndex].subCities[subcityIndex].name; 
            }
            this.isModal = false;
            this.$emit('select', cityIndex, subcityIndex);
        },
        openModal: function()
        {
            this.isModal = true;
        }
    },
    watch:  {
        selectedCityIndex: function()
        {
            if(this.selectedCityIndex !== -1 && this.selectedSubcityIndex !== -1)
            {
                this.selectedText = this.options[this.selectedCityIndex].cityName + " " + this.options[this.selectedCityIndex].subCities[this.selectedSubcityIndex].name; 
            }
        },
        selectedSubcityIndex: function()
        {
            if(this.selectedCityIndex !== -1 && this.selectedSubcityIndex !== -1)
            {
                this.selectedText = this.options[this.selectedCityIndex].cityName + " " + this.options[this.selectedCityIndex].subCities[this.selectedSubcityIndex].name; 
            }
        }
    }
}
</script>

<style scoped>
    .select-box {
        width: 100%;
        height: 44px;
        flex-shrink: 0;
        border-radius: 6px;
        color: var(--Gray-60, #6B7684);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: 17px; /* 94.444% */
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 16px;
        box-sizing: border-box;
        border-radius: 100px;
        border: 1px solid var(--gray-40-button-stroke, #D1D6DB);
        background: var(--Gray-primary-color2, #FFF);
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/components/atoms/LocationSelectBox.vue